module.exports = __webpack_public_path__ + "img/nav-1.66cf1e1.png";